var React = require('react');

function IconQuote (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#6db8e3;}\n"),React.createElement("title",{"key":1},"Asset 1"),React.createElement("g",{"id":"Layer_2","key":2},React.createElement("g",{"id":"Layer_1-2"},[React.createElement("path",{"className":"st0","d":"M13.9,30.8h9.3v26.5H0V34.6C0,14.1,8.6,4.3,27.8,0l3,8.8C18.2,13.4,13.1,20,13.9,30.8z","key":0}),React.createElement("path",{"className":"st0","d":"M55.1,30.8h9.3v26.5H41.2V34.6C41.2,14.1,49.8,4.3,69,0l3,8.8C59.4,13.4,54.3,20,55.1,30.8z","key":1})]))]);
}

IconQuote.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 72 57.3","style":{"enableBackground":"new 0 0 72 57.3"},"xmlSpace":"preserve"};

module.exports = IconQuote;

IconQuote.default = IconQuote;
